import styled from 'styled-components';
import { colors, fonts, media } from '../../../utils';

export const Tag = styled.span`
    display: inline-block;
    padding: 0.25em 0.5em;
    border-radius: 2rem;
    margin: 1rem 0.5rem;
    box-sizing: border-box;
    text-decoration: none;
    font-weight: bold;
    font-size: medium;
    background-color: ${colors.personality};
    color: ${colors.white} !important;
    text-align:center;
    transition: all 0.2s;

    cursor: pointer;

    &:hover {
        font-weight: bolder;
        text-decoration: none;
    }
`;

export const TagContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
`;

export const Container = styled.div`
    display: none;
    max-width: 1250px;
    margin: 0 auto;
    padding: 0 4vw;

    ${media.medium`
        display: block;
    `}
`;